import { defineComponent as _defineComponent } from 'vue'
import {defineComponent} from 'vue';
import {useHouseholds} from '@/components/calculator/form/useSimulationForm';
import MultiformListManager from '@/modules/multiForm/views/MultiformListManager.vue';
import SimulationFormStep2 from '@/components/calculator/form/SimulationFormStep2.vue';
import {FFBorrower} from '@/models/ExpertState';
import {FFHousehold} from '@/models/simulation/Simulation';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';


export default /*#__PURE__*/_defineComponent({
  __name: 'CashSimulationFormStep2',
  setup(__props) {

const {households,} = useHouseholds();


return { __sfc: true,households, MultiformListManager, SimulationFormStep2, FFBorrower, I18NGetter }
}

})